import {
  Box,
  Card,
  CardHeader,
  CardBody,
  Stack,
  Text,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  useSteps,
} from "@chakra-ui/react";

import React, { useState } from "react";
import StepOne from "./steps/Step1";
import StepTwo from "./steps/Step2";
import StepThree from "./steps/Step3";

const steps = [
  { title: "Select Type", description: "Select an Agreement Type" },
  { title: "Add Signers", description: "Add Signers" },
  { title: "Generate", description: "Let AI generate the Agreement" },
];

const Generate = () => {
  const { activeStep, setActiveStep } = useSteps({
    index: 1,
    count: steps.length,
  });

  const [formData, setFormData] = useState({
    agreementType: "",
    country: "",
    signers: [],
  });

  return (
    <Stack minH="100vh" mt="8rem">
      <Stepper index={activeStep} colorScheme="navy">
        {steps.map((step, index) => (
          <Step key={index}>
            <StepIndicator>
              <StepStatus
                complete={<StepIcon />}
                incomplete={<StepNumber />}
                active={<StepNumber />}
              />
            </StepIndicator>

            <Box flexShrink="0">
              <StepTitle color="gray.100">{step.title}</StepTitle>
              <StepDescription color="gray.400">{step.description}</StepDescription>
            </Box>

            <StepSeparator />
          </Step>
        ))}
      </Stepper>
      <Card mt="2rem">
        {/* <CardHeader>
          <Text>{steps[activeStep - 1].title}</Text>
        </CardHeader> */}
        <CardBody>
          {activeStep === 1 && (
            <StepOne formData={formData} setFormData={setFormData} setCurrentStep={setActiveStep} />
          )}
          {activeStep === 2 && (
            <StepTwo formData={formData} setFormData={setFormData} setCurrentStep={setActiveStep} />
          )}
          {activeStep === 3 && <StepThree formData={formData} setCurrentStep={setActiveStep} />}
        </CardBody>
      </Card>
    </Stack>
  );
};

export default Generate;
